import React from "react";
import { Grid, Container, Box } from "@mui/material";
// import SideMenu from "../components/SideMenu";
import TopBreadcrumb from "../components/TopBreadcrumb";
import EditProfile from "../components/EditProfile";
import { MdWidthFull } from "react-icons/md";

const Account = () => {
  return (
    <>
      <Container maxWidth="xl">
        <TopBreadcrumb />
        {/* <Grid container sx={{ width: "100%", marginBottom:"70px",alignItems:"center" }} spacing={4}> */}
          {/* <Grid item size={{ xs: 12, sm: 12, md: 3, lg: 2 }}>
            <SideMenu />
          </Grid> */}
          <Box sx={{width:"80%", margin:"0 auto"}}>
            <EditProfile />
          </Box>
        {/* </Grid> */}
      </Container>
    </>
  );
};

export default Account;
